// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2TX1O","disabled":"index-module--disabled--13cNn","small":"index-module--small--rjH3g"};